<template>
  <div class="bracelet-page">
    
    <div v-if="!imgUrl" class="warn-text">
      目前功能仅支持翡翠、和田玉和部分其他玉石（岫玉）的分类，更多玉石的分类正在优化中，敬请期待。
    </div>
    <!-- 其中input标签type="file"的参数
      capture表示，可以捕获到系统默认的设备，比如：camera照相机；camcorder摄像机；microphone录音，
      accept表示，直接打开系统文件目录，
      multiple属性，表示可以支持多选。 -->
    
    <div class="top-title">翡小鉴</div>

     <div v-if="imgUrlLoading" class="img-box">
       <div class="inner-box" style="color: #999">
          图片上传中…
       </div>
     </div>

     <div
      v-else
      class="img-box"
      :style="imgUrl ? `background: url(${imgUrl}) no-repeat center; background-size: contain` : `background: url(${normalImgUrl}) no-repeat center; background-size: contain`"
      @touchend="changeImage"
     />

     <div v-if="!imgUrl">
       <div style="color: #999">请添加手镯图片(示例如下)</div>
     </div>

     <div v-if="!imgUrl">
       <div class="show-img"></div> 
     </div>

    <input id='imgel' type="file" accept="image/*" @change="handleChange"> 

    <div v-if="braceletLoading" style="color: #999">
      翡翠识别中…
    </div>

     <div v-else style="min-width: 60%;">
      <div class="brand common" v-if="abc">
        <div class="left">货种</div>
        <div class="right">{{abc}}</div>
      </div>

      <div class="brand common" v-if="cate">
        <div class="left">类别</div>
        <div class="right">{{cate}}</div>
      </div>

      <div class="brand common" v-if="species">
        <div class="left">种水</div>
        <div class="right">{{species}}</div>
      </div>

      <div class="common" v-if="!detection" style="margin-right: 0">
        <div class="cent">图片不符合规范</div>
      </div>
      <div v-if="!detection" class="re-btn" @touchend="changeImage">重新上传</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import {
  uploadImage
} from '@/common/api/some.js'

export default {
  components: {},
  props: {},
  data () {
    return {
      normalImgUrl: 'https://oss.turingsenseai.com/1602579304081504808.png',

      imgUrl: '',
      imgUrlLoading: false, // 图片上传中

      abc: '', // 货种
      cate: '', // 类别
      species: '', // 种水
      braceletLoading: false, // 翡翠识别中

      detection: true,
    };
  },
  watch: {},  
  computed: {},
  methods: {
    changeImage () {
      if (this.imgUrlLoading) {
        console.log('不可以哦')
        return
      }
      document.getElementById('imgel').click();
    },
    handleChange (e) {
      if (!e.target.files[0]) return
      var self = this
      // 接口请求
      self.imgUrlLoading = true
      var file = e.target.files[0]
      // 创建读取文件的对象
      var reader = new FileReader();
      // 创建文件读取相关的变量
      var imgFile;
      // 读取结果
      reader.onloadend = function (e) {
        self.imgUrl = e.target.result
        if (!this.detection) {
          this.detection = true
          self.getBase64(e.target.result)
        }
      }
      // 正式读取文件 读取结果 会在onload里打印
      reader.readAsDataURL(file);
    },
    async getBase64 (imageUrl) {
      // base64
      uploadImage({
        imgB64: imageUrl.split(',')[1]
      }).then(res => {
        if (res.errorCode === 0) {
          this.braceletLoading = true // 翡翠识别中
          this.getFinalResult(res.imageUrl)
        } else {
          // TODO
        }
        this.imgUrlLoading = false // 图片上传完毕
      })  
    },

    // 翡翠识别结果
    async getFinalResult (imageUrl) {
      axios({
        method: 'post',
        url: 'https://api.turingsenseai.com/api/jade',
        data: {
          imageUrl
        }
      }).then(res => {
        console.log('鉴别结果res:', res)
        if (res.data.detection) {
          console.log(' ---————————————————————————    真')
          this.detection = true
        } else {
          // todo wrong
          console.log(' ---———————————————————————————— 假')
          this.detection = false
        }
        this.abc = res.data.abc
        this.cate = res.data.cate
        this.species = res.data.species

        this.braceletLoading = false // 翡翠识别完毕
      })
    }
  },
  created () {},
  mounted () {}
};
</script>
<style lang="scss" scoped>
.bracelet-page{
  width: 100%;
  height: 100vh;
  background: url('https://oss.turingsenseai.com/1602569959147307916.png') no-repeat center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px; 
  position: relative;
  // 提示术语
  .warn-text{
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 40px;
    font-weight: bold;
  }
  .top-title{
    font-size: 40px;
    font-weight: 500;
    margin-bottom: 50px
  }
  .img-box{
    width: 60%;
    height: 0;
    padding-bottom: 60%;
    background: transparent;
    margin-bottom: 50px;
    border: 20px solid #c9e4d9;
    cursor: pointer;
    background-size: cover !important;
    .inner-box{
      text-align: center;
      margin-top: 47%;
    }
  }
  .brand{
    border-bottom: 1px solid #91ada9;
    padding-bottom: 10px;
  }
  #imgel{
    display: none;
  }

  .re-btn{
    color: #fff;
    background: #86D1AD;
    padding: 15px 25px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
    font-size: 26px !important;
  }
}
.common{
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  .left{
    text-align: left;
    color: #999;
  }
  .right{
    text-align: right;
  }
}
.cent{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.show-img{
  margin-top: 30px;
  width: 40vh;
  height: 0;
  padding-bottom: 60%;
  background: url('https://oss.turingsenseai.com/1602584323425404091.png') no-repeat center;
  background-size: contain;
}
</style>
